import { tw } from 'utils/classnames'
import { useProjectDraft } from '../project-draft-context'
import { SkillLevel } from '@web/gen/service/creativefabrica/social/v2/types_pb'
export const SkillLevelSelection = () => {
  const { skillLevel, setSkillLevel } = useProjectDraft()

  const handleSkillLevelClick = (level: SkillLevel) => {
    setSkillLevel(level)
  }

  return (
    <div className="mt-5 flex flex-col tablet:flex-row justify-start items-center w-full">
      <p className="text-12 text-cf-grey-800 font-bold flex-shrink-0 tablet:w-24 w-full text-left">
        Skill level{' '}
      </p>
      <div className="flex flex-col mt-2 tablet:mt-0 tablet:flex-row justify-stretch items-center w-full gap-2">
        <button
          type="button"
          onClick={() => handleSkillLevelClick(SkillLevel.BEGINNER)}
          className={tw(
            'h-9 rounded-2 border-2 border-cf-transparent-grey-1000-12 w-full text-center select-none flex-grow flex items-center justify-center font-semibold text-14 cursor-pointer',
            skillLevel === SkillLevel.BEGINNER
              ? 'bg-cf-purple-200 border-cf-purple-300 text-cf-purple-900 hover:bg-cf-purple-400 hover:border-cf-purple-500 active:bg-cf-purple-300 active:border-cf-purple-400'
              : 'hover:bg-cf-purple-100 active:bg-cf-purple-50',
          )}
        >
          Beginner
        </button>
        <button
          type="button"
          onClick={() => handleSkillLevelClick(SkillLevel.INTERMEDIATE)}
          className={tw(
            'h-9 rounded-2 border-2 border-cf-transparent-grey-1000-12 w-full text-center select-none flex-grow flex items-center justify-center font-semibold text-14 cursor-pointer',
            skillLevel === SkillLevel.INTERMEDIATE
              ? 'bg-cf-purple-200 border-cf-purple-300 text-cf-purple-900 hover:bg-cf-purple-400 hover:border-cf-purple-500 active:bg-cf-purple-300 active:border-cf-purple-400'
              : 'hover:bg-cf-purple-100 active:bg-cf-purple-50 text-cf-grey-800',
          )}
        >
          Intermediate
        </button>
        <button
          type="button"
          onClick={() => handleSkillLevelClick(SkillLevel.ADVANCED)}
          className={tw(
            'h-9 rounded-2 border-2 border-cf-transparent-grey-1000-12 w-full select-none text-center flex-grow flex items-center justify-center font-semibold text-14  cursor-pointer',
            skillLevel === SkillLevel.ADVANCED
              ? 'bg-cf-purple-200 border-cf-purple-300 text-cf-purple-900 hover:bg-cf-purple-400 hover:border-cf-purple-500 active:bg-cf-purple-300 active:border-cf-purple-400'
              : 'hover:bg-cf-purple-100 active:bg-cf-purple-50 text-cf-grey-800',
          )}
        >
          Advanced
        </button>
      </div>
    </div>
  )
}
